/* global chrome */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import './login.css'
import lock from '../Images/padlock.png'

import { useMsal } from '@azure/msal-react';
import pkceChallenge from "pkce-challenge";
import { Button, Container, Stack, Typography } from '@mui/material';
import logo from '../Images/LiznrLogo.svg'
import Loader from '../Loader/Loader';
import * as microsoftTeams from "@microsoft/teams-js";

import {jwtDecode} from 'jwt-decode';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';


const Login = () => {
  const navigate = useNavigate()
  const [input, setInput] = useState({
    username: "",
    password: "",
  });
  const [user, setUser] = useState(null);
  const [showpassword, setShowpassword] = useState(false)


  const ext_backend = process.env.REACT_APP_PORT_8000;
  const auth_backend = process.env.REACT_APP_PORT_8001;
  const privacy_policy = process.env.REACT_APP_PRIVACY_POLICY
  const terms_and_conditions = process.env.REACT_APP_TERMS_OF_SERVICE
  const Liznr_sso = process.env.REACT_APP_LIZNR_SSO_API

  

  const [authToken, setAuthToken] = useState(null)
  const [accessToken, setAccessToken] = useState(null)
  const [challenge, setChallenge] = useState(null)

  const [isLoading, setIsLoading] = useState(false)
  const [loginMessage,setLoginMessage] = useState("")
  const clientId = ''
  // const redirectUri = chrome.identity.getRedirectURL()
  const tenantID = ''
  const baseUrl = "https://graph.microsoft.com"



  //   const getAccessTokenAndUserInfo = async (authToken) => {
  //     try {
  //       // Fetch the access token
  //       const tokenResponse = await fetch(
  //         `https://login.microsoftonline.com/${tenantID}/oauth2/v2.0/token`,
  //         {
  //           method: 'POST',
  //           headers: {
  //             'Content-type': 'application/x-www-form-urlencoded',
  //           },
  //           credentials: 'omit',
  //           body: `client_id=${clientId}&scope=${baseUrl}/.default&grant_type=authorization_code&code=${authToken}&redirect_uri=${redirectUri}&code_verifier=${challenge?.code_verifier}`,
  //         }
  //       );

  //       const tokenData = await tokenResponse.json();
  //       const accessToken = tokenData.access_token;
  //       setAccessToken(accessToken);
  //       console.log('Access Token:', accessToken);

  //       // Fetch user info
  //       if (accessToken) {
  //         const userInfoResponse = await fetch(
  //           'https://graph.microsoft.com/v1.0/me',
  //           {
  //             headers: {
  //               Authorization: `Bearer ${accessToken}`,
  //             },
  //           }
  //         );
  //         const userInfo = await userInfoResponse.json();
  //         console.log('User Info:', userInfo);
  //         const email = userInfo.userPrincipalName.split('#')[0];
  //         console.log('Email:', email);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching access token or user info:', error);
  //     }
  //   };

  //   useEffect(() => {
  //     if (authToken) {
  //       getAccessTokenAndUserInfo(authToken);
  //     }
  //   }, [authToken]);

  //  useEffect(() => {
  //     chrome.storage.sync.get(['authToken','challenge'], (result) => {
  //       if (result.authToken && result.challenge) {

  //         setAuthToken(result.authToken)

  //         // getAccessToken(result.authToken)
  //         setChallenge(result.challenge)



  //       }
  //     });
  //   }, [])


  const handleInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    setInput({ ...input, [name]: value });

  }


  // extra


  const handleSubmit = async () => {
    let url = `${ext_backend}login/`;
    setIsLoading(true)
    await axios.post(url, input)
      .then((res) => {
        const { access, refresh, username } = res.data;
        localStorage.setItem('username', username);
        // Store tokens in localStorage or sessionStorage
        localStorage.setItem('access_token', access);
        localStorage.setItem('refresh_token', refresh);

        setIsLoading(false)
        // alert("Login successful");
        toast("Login successful");

        // Clear input fields
        setInput({
          username: "",
          password: "",
        });



        // Navigate to the home page or another page
        navigate('/');
      })
      .catch((error) => {
        console.log("Error:", error);
        // alert("Login failed");
        setIsLoading(false)
        toast.error("Login failed")
      });
  }



  // 19

  const loginControl = async (token) => {
    try {

      // if(localStorage.getItem('access_token') && localStorage.getItem('refresh_token')){
      //   localStorage.removeItem('access_token');
      //   localStorage.removeItem('refresh_token');
      // }
      setIsLoading(true)
      const response = await axios.post(`${auth_backend}oauth/token/`, { token });
      // console.log('Backend response:', response.data);
      localStorage.setItem('access_token', response.data.access);
      localStorage.setItem('refresh_token', response.data.refresh);
      localStorage.setItem('username', response.data.username);
      
      setIsLoading(false)
      toast("Login successful");
      navigate('/'); // Navigate after login
    } catch (error) {
      setIsLoading(false)
      toast.error("Login failed")
      console.error('Error:', error);
    }
  };

  // const handleAuthClick = () => {
  //   chrome.identity.getAuthToken({ interactive: true }, async (token) => {
  //     if (chrome.runtime.lastError) {
  //       console.error('OAuth error:', chrome.runtime.lastError);
  //     } else {
  //       console.log('Token recevied');
  //     }
  //     if (token) {
  //       loginControl(token);
  //     }
  //     else {
  //       console.log("Token not found");
  //     }
  //   });
  // };


  const handleAuthClick = () => {
    const redirectUri = chrome.identity.getRedirectURL();
    console.log(redirectUri);
    
    // Construct the OAuth URL with `prompt=select_account`
    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${process.env.REACT_APP_CLIENT_ID}&redirect_uri=${redirectUri}&response_type=token&scope=openid%20email%20profile&prompt=select_account`;

    // Open the OAuth flow
    chrome.identity.launchWebAuthFlow({
        url: authUrl,
        interactive: true
    }, function (redirectUrl) {
        if (chrome.runtime.lastError) {
            console.error('OAuth error:', chrome.runtime.lastError);
            return;
        }

        if (redirectUrl) {
            // Extract the access token from the URL
            const params = new URLSearchParams(redirectUrl.split('#')[1]);
            const accessToken = params.get('access_token');

            if (accessToken) {
                // Now you can send this token to your backend to store user info
                loginControl(accessToken);
            } else {
                console.log('No access token received');
            }
        }
    });
};

  // Password
  const togglePassword = () => {
    setShowpassword(!showpassword)
  }

  // For microsoft 17-11-2024
  const handleSuccess = async (data) => {

    try {
      // if (data) {
      //   localStorage.setItem('picture', data.picture);
      // }
      console.log("Received Data",data);
      
      setIsLoading(true)
      await axios.post(`${ext_backend}auth/google/`, {
        email: data.email,
        display_name: data.name,

      }).then((res) => {
        const { access, refresh } = res.data;
        setIsLoading(false)
        setLoginMessage("Login successful");
        // Store tokens in localStorage or sessionStorage
        // localStorage.setItem('access_token', access);
        // localStorage.setItem('refresh_token', refresh);
        sessionStorage.setItem('access_token', access);
        sessionStorage.setItem('refresh_token', refresh);
        sessionStorage.setItem('username', res.data.username);



        navigate('/')

      })
    } catch (error) {
      setIsLoading(false)
      console.log(error);
      setLoginMessage(error.message);
      toast.error("Login failed")

    }

  }

  // const { instance } = useMsal();

  // const handleLogin = async() => {
  //     await instance.loginPopup(["openid", "profile", "User.Read"]).then((response)=>{
  //         console.log(response.account.username);
  //         handleSuccess({email:response.account.username,name:response.account.name})

  //     }).catch(e => {
  //         console.error(e);
  //     });
  // };




  // Microsoft 17-11-2024
  // const handleLogin = async () => {
  //   const challengeResponse = await pkceChallenge()
  //   const authUrl = `https://login.microsoftonline.com/${tenantID}/oauth2/v2.0/authorize` +
  //   `?client_id=${clientId}` +
  //   `&response_type=code` +
  //   `&redirect_uri=${encodeURIComponent(redirectUri)}` +
  //   `&response_mode=query` +
  //   `&scope=openid profile User.Read email` +
  //   `&state=${Math.random().toString(36).substring(7)}` +
  //   `&code_challenge=${challengeResponse.code_challenge}` +
  //   `&code_challenge_method=S256` +
  //   `&prompt=login`;

  //   chrome.identity.launchWebAuthFlow({
  //     url: authUrl,
  //     interactive: true
  //   }, async (redirectUrl) => {
  //     if(redirectUrl){
  //       const params = new URLSearchParams(new URL(redirectUrl).search);
  //       const code = params.get('code');
  //       chrome.storage.sync.set({ authToken: code, challenge:challengeResponse });


  //     }
  //   });
  // }

  // Teams
  const handleMicrosoftSSO = async () => {
    try {
      // Initialize Microsoft Teams SDK
      await microsoftTeams.app.initialize();
      

      const result = await microsoftTeams.authentication.getAuthToken();
  
      // Process the result
      // console.log("SSO successful!", result);
      if(result){
        const decodedToken = jwtDecode(result);
        const data = {
          "email" : decodedToken.preferred_username || decodedToken.unique_name,
          "name" : decodedToken.name
        }
        
        
        handleSuccess(data);


      }
  
    } catch (error) {
      console.error("SSO failed!", error);
      setLoginMessage(error.message);
    }
  };
  


  const dashboard = process.env.REACT_APP_DASHBOARD


  return (
    <>

      {/* <div class="w-70 backdrop-blur-lg bg-opacity-80  shadow-lg p-5 bg-gray-900 text-white"> */}
      {/* <div class="p-4 text-white"> */}
        {/* <div className='bg-red-500' onClick={GoogleLogin} >Login With Google</div> */}
        {/* <div class="flex flex-col items-start text-sm border-l-2 border-black pl-2 mb-4"> */}
          {/* <h1 className='text-black text-[15px] font-bold '>Sign in</h1> */}
          {/* <p className='text-black'>Don't have an account? <Link to='/Registration' class="text-blue-500 hover:text-blue-700 register-link">Register now</Link></p> */}

        {/* </div> */}

        {/* <div> */}
          {/* <div className="mb-2 name-field">
            <label for="name" class="block mb-0 text-sm font-medium text-black">Your name</label>
            <i class="far fa-user" style={{ color: "black" }}></i>
            <input
              type="text"
              id="username"
              name="username"
              class="bg-white border border-gray-300 outline-none text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-[#DE00FF] focus:border-blue-500 w-full py-2.5 px-10"
              placeholder="Andrew Jackson"
              required
              onChange={handleInput}
              value={input.username}
            />
          </div>
          <div class="mb-4 password-field">
            <label for="password" class="block mb-0 text-sm font-medium text-black">Your password</label>
            <i className='lock'><img src={lock} alt="lock" style={{ width: "18px" }} /></i>
            <input
              type={`${showpassword ? "text" : "password"}`}
              id="password"
              name="password"
              class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:[#DE00FF] focus:ring-[#DE00FF] w-full py-2.5 px-10 outline-none"
              placeholder={`${showpassword ? input.password : "**********"}`}
              required
              onChange={handleInput}
              value={input.password}
            />
            {!showpassword ? <i class="far fa-eye" style={{ color: "black" }} onClick={togglePassword}></i>
              : <i class="far fa-eye-slash" style={{ color: "black" }} onClick={togglePassword}></i>}
          </div>
          <div>
            <p class="text-red-500 pb-1"></p>
          </div> */}

          {/* <div class="flex flex-col items-center justify-between mb-4"> */}
            {/* <button
              onClick={handleSubmit}

              class="text-white hover:bg-purple-700 focus:ring-2 focus:ring-blue-300 font-medium rounded-lg text-sm mb-0 py-2 px-5 w-full sm:w-auto login"
            >
              Login
            </button>

            <div className='text-center or'>
              <div className='before'></div>
              <span className="text-black">or</span>
              <div className='after'></div>

            </div> */}


               {/* <button onClick={handleAuthClick} className='border border-grey-200 h-[40px] w-[40px]  bg-white rounded-full text-black flex justify-content-center align-items-center'><i className="ci ci-google ci-1x "></i></button> */}

            {/* New code start */}
            {!isLoading ? <>
              <Container className='!px-0'>
              
              <Stack>
                <Typography className='!text-[22px] !leading-[28px] py-[40px]'>
                  Make meetings effortless<br /> with Liznr
                </Typography>
              </Stack>
              <Stack spacing={1} >
                {/* <button onClick={handleAuthClick} className='flex justify-between border border-grey-200  p-2  px-4  !rounded-md  bg-white align-items-center'>
                  <i className="ci ci-google ci-2x p-2"></i>

                  <p className='text-black text-md fw-medium'>Signup with Google</p>
                  
                  <ArrowForwardIcon/>
                </button> */}

                <button onClick={handleMicrosoftSSO} className=' flex justify-between border border-grey-200  p-2  px-4  !rounded-md  bg-white align-items-center'>
                  <i className="ci ci-microsoft ci-2x p-2"></i>

                  <p className='text-black text-md fw-medium'>Signup with Microsoft</p>
                  <ArrowForwardIcon/>
                </button>
              </Stack>
              <Stack className='px-3 py-[40px]'>
                <hr />
              </Stack>
              <Stack className='!text-[14px] text-center !leading-[28px] py-[4px]'>
                <Typography >
                  New to Liznr?
                </Typography>
              </Stack>
              <Stack>
                <Link to={dashboard} target='_blank'> 
                <Button className=' p-2 !text-[14px] w-full !normal-case !text-[#4F5B92]'>
                  Create your team
                </Button>
                </Link>
              </Stack>

              <Stack>
                <Typography className='!text-[12px]  !leading-[18px] pt-10'>
                  By signing up you agree to our <Link className="!text-[#4F5B92] underline" to={terms_and_conditions} target='_blank'>terms and conditions</Link>  and
                  <br/> 
                  <Link className="!text-[#4F5B92] underline" to={privacy_policy} target='_blank' >privacy policy.</Link>
                </Typography>
              </Stack>
            </Container>

          </> : <Loader />}
        
            {/* <div className="SocialLogin text-center flex flex-col justify-center">
      <div className='flex justify-center pt-2'>
        <button onClick={handleLogin} className='border border-grey-200 h-[40px] w-[40px]  bg-white rounded-full text-black flex justify-content-center align-items-center'><i className="ci ci-google ci-1x "></i></button>
      </div>
      
      </div>
       */}
          {/* </div> */}
        {/* </div> */}
      {/* </div> */}

    </>
  );
}

export default Login;